<!--src/components/Footer.svelte-->
<script>
import { t } from "../i18n";
function getLanguageInPath() {
  return "process.env.APP_LOCALE";
}

import { onMount } from 'svelte';
onMount(async () => {
    const selectLangBtn = document.getElementById("select-language");
    const selectLangBtnText = document.querySelector("#select-language > span[i18n='languages_span']");
    const languageList = document.getElementById('languages');
    const langOptions = document.querySelector('.lang-option');
    const langInPath = getLanguageInPath().replace('_', '-');
    const arrowToggle = document.querySelector('.material-icons-outlined');
    const currentLangOption = document.querySelector(`.lang-option[hreflang=${langInPath}]`);
    // If empty, either there is not lang in path or the lang isn't a paid one
    if (langOptions) langOptions.classList.remove('selected');
    if (currentLangOption.length === 0) {
        selectLangBtnText.textContent = document.getElementById("i18n-languages_span").textContent;
    } else {
        currentLangOption.classList.add('selected');
        selectLangBtnText.textContent = document.querySelector(`.lang-option[hreflang=${langInPath}] > span`).textContent;
    }

    selectLangBtn.addEventListener('click', function(event) {
        event.stopPropagation();
        if (event.target.getAttribute("aria-expanded") === "false") {
            event.target.setAttribute("aria-expanded", "true")
            arrowToggle.innerHTML = 'arrow_drop_up';
            languageList.classList.add("expanded");
        } else {
            event.target.setAttribute("aria-expanded", "false")
            arrowToggle.innerHTML = 'arrow_drop_down';
            languageList.classList.remove("expanded");
        }
    });
    function closeMenu(event) {
        const insideLanguageDOM = event.target.id === 'select-language' || event.target.id === 'language-dropdown-container';
        if (!insideLanguageDOM) {
            selectLangBtn.setAttribute("aria-expanded", "false");
            arrowToggle.innerHTML = 'arrow_drop_down';
            languageList.classList.remove("expanded");
        }
    }
    document.body.addEventListener("click", closeMenu);
});
</script>

<!-- Footer  -->
<!-- START: Footer snippet. Expects user.js loaded already on the page. -->
<!-- <link rel="stylesheet" type="text/css" href="<?php cache_bust('/css/footer.css') ?>" /> -->
<!-- <link href="https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined" rel="stylesheet" /> -->
<!-- <script src="<?php cache_bust('/js/footer.js') ?>"></script> -->
<footer role="contentinfo"><div class="footer-content">
    <ul id="info-links">
        <li><a href="https://vpn.getadblock.com/privacy/">{$t('privacy_policy_nav_btn')}</a></li>
        <li aria-hidden="true">&bull;</li>
        <li><a href="https://vpnsupport.getadblock.com">{$t('help_btn_text')}</a></li>
    </ul>
    <ul id="social-icons">
        <li>
            <a href="https://www.facebook.com/heres.adblock/" class="without-focus">
                <img src="./assets/images/footer/facebook.svg" alt="facebook"/>
            </a>
        </li>
        <li>
            <a href="https://twitter.com/getadblock" class="without-focus">
                <img src="./assets/images/footer/twitter.svg" alt="twitter"/>
            </a>
        </li>
        <li>
            <a href="https://www.linkedin.com/company/adblock/" class="without-focus">
                <img src="./assets/images/footer/linkedin.svg" alt="linkedin"/>
            </a>
        </li>
    </ul>
    <hr>
    <div class="bottom-of-footer">
        <p>
            {$t('copyright_text', {"$replace$": "2022"})}
        </p>
        <div id="language-dropdown-container">
            <button
                id="select-language"
                aria-haspopup="true"
                aria-expanded="false"
                aria-controls="languages"
            >
                <span i18n="languages_span">Languages</span>
                <i role="img" aria-hidden="true" class="material-icons-outlined">arrow_drop_down</i>
            </button>
            <ul role="menu" id="languages">
                <li role="menuitem">
                    <a class="lang-option" href="/de/" hreflang="de">
                        <i role="img" aria-hidden="true" class="material-icons-outlined">check</i>
                        <span>Deutsch (DE)</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a class="lang-option" href="/en/" hreflang="en">
                        <i role="img" aria-hidden="true" class="material-icons-outlined">check</i>
                        <span>English (US)</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a class="lang-option" href="/es/" hreflang="es">
                        <i role="img" aria-hidden="true" class="material-icons-outlined">check</i>
                        <span>Espanol (España) (ES)</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a class="lang-option" href="/fr/" hreflang="fr">
                        <i role="img" aria-hidden="true" class="material-icons-outlined">check</i>
                        <span>Francais (FR)</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a class="lang-option" href="/it/" hreflang="it">
                        <i role="img" aria-hidden="true" class="material-icons-outlined">check</i>
                        <span>Italiano (IT)</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a class="lang-option" href="/ja/" hreflang="ja">
                        <i role="img" aria-hidden="true" class="material-icons-outlined">check</i>
                        <span>日本語 (JA)</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a class="lang-option" href="/nl/" hreflang="nl">
                        <i role="img" aria-hidden="true" class="material-icons-outlined">check</i>
                        <span>Nederlands (NL)</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a class="lang-option" href="/pt_BR/" hreflang="pt-BR">
                        <i role="img" aria-hidden="true" class="material-icons-outlined">check</i>
                        <span>Portugues (Brasil) (BR)</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a class="lang-option" href="/ru/" hreflang="ru">
                        <i role="img" aria-hidden="true" class="material-icons-outlined">check</i>
                        <span>Pусский (RU)</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a class="lang-option" href="/sv/" hreflang="sv">
                        <i role="img" aria-hidden="true" class="material-icons-outlined">check</i>
                        <span>Svenska (SE)</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a class="lang-option" href="/zh_CN/" hreflang="zh-CN">
                        <i role="img" aria-hidden="true" class="material-icons-outlined">check</i>
                        <span>中国人 (CN)</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a class="lang-option" href="/zh_TW/" hreflang="zh-TW">
                        <i role="img" aria-hidden="true" class="material-icons-outlined">check</i>
                        <span>中國人 (TW)</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <!-- Dynamic translations below -->
    <span i18n="languages_span" id="i18n-languages_span" class="hidden-dynamic-translation" style="display: none;"></span>
</div></footer>
<!-- END: Footer snippet -->

<style>
/* Footer Styling */
:root {
  --height-dropdown-btn: 40px;
}
html *:not(i) {
  font-family: "Lato";
}

html[lang="el"] *:not(i) {
  font-family: "Open Sans";
}

footer {
  background-color: #E6E6E6;
  border: none;
  color: #666;
  width: 100%;
  min-height: 248px;
}
footer * {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  color: #666;
}

.footer-content {
  margin: 0 auto;
  width: 1024px;
  min-width: 80%;
  max-width: 80%;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 55px 0 40px 0;
}

footer a:hover,
footer a:hover img {
  color: #333;
}

footer hr {
  color: #C6C6C6;
  background-color: #C6C6C6;
  width: 100%;
  height: 1px;
}

footer .bottom-of-footer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
}

footer ul li,
footer ul li a {
  display: inline-block;
  color: #666;
}

#info-links li[aria-hidden="true"] {
  margin: 0 8px;
}

#social-icons li {
  margin: 0;
}

#social-icons a:hover img[alt="facebook"] {
  content: url("./assets/images/footer/facebook_hovered.svg");
}

#social-icons a:hover img[alt="linkedin"] {
  content: url("./assets/images/footer/linkedin_hovered.svg");
}

#social-icons a:hover img[alt="twitter"] {
  content: url("./assets/images/footer/twitter_hovered.svg");
}

#language-dropdown-container {
  position: relative;
}

#languages {
  position: absolute;
  bottom: var(--height-dropdown-btn);
  background-color: #F4F4F4;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
  width: 100%;
  min-width: 100%;
  color: #333;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

#languages > li span {
  line-height: 240%;
}

#languages.expanded {
  display: block;
}
#languages:not(.expanded) {
  display: none;
}

#languages > li {
  padding: 0 10px;
  margin: 0;
  display: block;
  color: #333;
  width: 100%;
}

#languages .lang-option {
  border: none;
  background: transparent;
  padding: 0;
  display: flex;
  margin: 0;
  align-items: center;
  color: #333;
  cursor: pointer;
  width: 100%;
}

#languages li:hover {
  background: #FFFFFF;
}

#languages .lang-option > i {
  font-size: 18px;
  margin-right: 10px;
  opacity: 0;
  color: #333;
}

#languages .lang-option.selected > span,
#languages .lang-option.selected > i {
  font-weight: bold;
  opacity: 1;
}

#select-language {
  display: flex;
  width: 100%;
  font-size: 16px;
  appearance: none;
  border: none;
  background: transparent;
  padding: 0 16px 0 38px;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  height: var(--height-dropdown-btn);
  min-width: 248px;
  min-height: 40px;
  border-radius: 6px;
}

#select-language[aria-expanded="true"] {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

#select-language > [i18n="languages_span"] {
  text-transform: capitalize;
}

#select-language:focus,
#select-language:active,
#select-language:hover,
#select-language[aria-expanded="true"] {
  background-color: #F4F4F4;
}

#select-language:focus > span,
#select-language:active > span,
#select-language:hover > span,
#languages .lang-option > span {
  color: #333;
}

#select-language > .material-icons {
  padding-top: 0;
  appearance: none;
  border: none;
  background: transparent;
}

#social-icons a {
  margin: 0;
  padding: 0;
  display: inline-block;
}
#social-icons img {
  height: 32px;
  width: 32px;
  margin: 19px calc(15px / 2) 10px calc(15px / 2);
}

footer p {
  text-align: left;
  font-weight: 400;
  padding: 8px 0px 0px 4px;
}

@media screen and (max-width: 846px) {
  footer .bottom-of-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (max-width: 705px) {
  html[lang="ru"] #info-links {
    text-align: center;
  }
  html[lang="ru"] .break {
    height: 0;
    width: 0;
    overflow: hidden;
    display: block;
  }
}

@media screen and (max-width: 660px) {
  html[lang="fr"] #info-links {
    text-align: center;
  }
  html[lang="fr"] .break {
    height: 0;
    width: 0;
    overflow: hidden;
    display: block;
  }
}

@media screen and (max-width: 645px) {
  html[lang="pt_BR"] #info-links,
  html[lang="it"] #info-links,
  html[lang="es"] #info-links {
    text-align: center;
  }
  html[lang="pt_BR"] .break,
  html[lang="it"] .break,
  html[lang="es"] .break {
    height: 0;
    width: 0;
    overflow: hidden;
    display: block;
  }
}

@media screen and (max-width: 607px) {
  html[lang="de"] #info-links,
  html[lang="ja"] #info-links {
    text-align: center;
  }
  html[lang="de"] .break,
  html[lang="ja"] .break {
    height: 0;
    width: 0;
    overflow: hidden;
    display: block;
  }
}

@media screen and (max-width: 560px) {
  html[lang="en"] #info-links,
  html[lang="sv"] #info-links {
    text-align: center;
  }
  html[lang="en"] .break,
  html[lang="sv"] .break {
    height: 0;
    width: 0;
    overflow: hidden;
    display: block;
  }
}

@media screen and (max-width: 515px) {
  html[lang="zh_CN"] #info-links,
  html[lang="zh_TW"] #info-links,
  html[lang="nl"] #info-links {
    text-align: center;
  }
  html[lang="zh_CN"] .break,
  html[lang="zh_TW"] .break,
  html[lang="nl"] .break {
    height: 0;
    width: 0;
    overflow: hidden;
    display: block;
  }
}

a {
  text-decoration: none;
  outline: none;
  cursor: pointer;
}

li, ul {
  border: 0;
  margin: 0;
  padding: 0;
  font-size: 100%;
  zoom: 1;
}

#select-language:focus,
#select-language:active,
#select-language:hover,
#select-language[aria-expanded="true"] {
  background-color: #fff;
}
</style>
